

import './SubAdmin.css';
import React, { useState, useEffect } from 'react';
import { Avatar, Box, Button, Grid2, TextField } from '@mui/material';
import Header from '../Header/Header';
import Pagination from '@mui/material/Pagination';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import consts from "../../constant";
import Axios from "axios";
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import { ToastContainer, toast } from "react-toastify";
const drawerWidth = 260;

const SubAdmin = () => {

  const theme = useTheme();
  const lg = useMediaQuery(theme.breakpoints.up('lg'));

  const back = useNavigate();
  // const detail = useLocation();

  const [reason, setreason] = useState();

  const navigate = useNavigate()
  const Navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setloading] = useState(true);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPages] = useState(0)
  const [detail, setDetail] = useState([]);
  const [showDetail, setShowDetail] = useState(false);

  console.log(detail, 'details');

  const getUser = async () => {
    Axios.get(
      `${consts.BackendUrl}/users/getUsersAdmin?limit=${limit}&page=${page}`,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers": "Content-Type, Authorization",
          "Access-Control-Allow-Credentials": "true",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: localStorage.getItem("adminToken"),
        },
      }
    )
      .then((res) => {
        console.log(res, 'res');
        if (res?.data?.result?.length > 0) {
          setData(res?.data?.result);
          setTotalPages(res?.data?.totalPages)
        } else {
          console.log("Data Not Found");
        }
      })
      .catch((err) => {
        console.log("", err);
      });
  }
  useEffect(() => {
    if (localStorage.getItem("adminToken")) {
      getUser();
    } else {
      Navigate(`/${consts.route + '/login'}`);
    }
  }, [limit, page]);

  const array = ["S.no", "Name", "Email", "Block", "Verify", 'TotalBalance', "Action"];


  const Resume = (data) => {
    console.log(data, 'data1');

    Axios.post(
      `${consts.BackendUrl}/users/suspendUsersandMasters`,
      { id: data._id, block: data.block },
      {
        headers: {
          Authorization: localStorage.getItem("adminToken"),
        },
      }
    )
      .then((res) => {
        toast.success(`${res?.data.message}`, {
          duration: 4000,
          position: "top-center",
          style: {
            padding: "1rem",
            fontSize: "15px",
            color: "green",
            fontWeight: "bold",
          },
          className: "",

          // Custom Icon
          icon: "👏",

          // Change colors of success/error/loading icon
          iconTheme: {
            primary: "#000",
            secondary: "#fff",
          },

          // Aria
          ariaProps: {
            role: "status",
            "aria-live": "polite",
          },
        });

        setTimeout(() => {
          setShowDetail(false);
          getUser();
        }, 2600)
      })
      .catch((err) => {
        toast.error(`${err?.response?.data?.message}`, {
          duration: 4000,
          position: "top-center",

          // Styling
          style: {
            backgroundColor: "#fc1922",
            padding: "1rem",
            fontSize: "18px",
            color: "white",
            fontWeight: "bold",
          },
          className: "",

          // Custom Icon
          icon: "",

          // Change colors of success/error/loading icon
          iconTheme: {
            primary: "#000",
            secondary: "#fff",
          },

          // Aria
          ariaProps: {
            role: "status",
            "aria-live": "polite",
          },
        });
      });
  };
  return (
    <div className="UserList">
      <Box sx={{ display: lg ? 'flex' : 'block' }}>
        <Header />
        <Box
          component="main"
          sx={{ flexGrow: 1, p: 5, width: { lg: `calc(100% - ${drawerWidth}px)` }, marginTop: '50px' }}
        >
          <Grid2 container spacing={2}>
            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>

              {showDetail ?
                <>
                  <div>
                    <Button variant="contained" onClick={() => setShowDetail(false)}>
                      Back
                    </Button>
                  </div>
                  <div className="custom_table">



                  </div>
                </>
                : <div className="custom_table">
                  <div className='display-2 p-10'>
                    <div className='display-1 '>
                      <div className='date-field'>
                        <TextField id="outlined-basic" type='date' variant="outlined" />
                      </div>
                      <div className='date-field'>
                        <TextField id="outlined-basic" type='date' variant="outlined" />
                      </div>
                    </div>
                    <div>
                      <Button variant='contained' onClick={(() => { setShowDetail(true) })}>
                        Add SubAdmin
                      </Button>
                    </div>
                  </div>



                  <TableContainer >
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          {array.map((item) => (
                            <TableCell align="center">{item}</TableCell>
                          ))}
                          {/* <TableCell>S.No</TableCell>
                                               <TableCell align="left">User</TableCell>
                                               <TableCell align="center">Email id</TableCell>
                                               <TableCell align="center">Email Status</TableCell>
                                               <TableCell align="center">Kyc Status</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.map((value, index) => (
                          <TableRow
                            key={value.name}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell component="th" scope="row">
                              {limit * (page - 1) + index + 1}
                            </TableCell>
                            <TableCell align="center">

                              {value?.name ? value?.name : "User"}

                            </TableCell>

                            <TableCell align="center">

                              {value?.email}

                            </TableCell>
                            <TableCell align="center">
                              {value?.block ?
                                <BlockOutlinedIcon sx={{ fill: 'red' }} /> :
                                <CheckCircleOutlineOutlinedIcon sx={{ fill: 'green' }} />}

                            </TableCell>
                            <TableCell align="center">
                              {value.email_verify == "true"
                                ? <CheckCircleOutlineOutlinedIcon sx={{ fill: 'green' }} />
                                : <CancelOutlinedIcon sx={{ fill: 'red' }} />
                              }
                            </TableCell>
                            <TableCell align="center">

                              {value.TotalBalance > 0 ? value.TotalBalance.toFixed(6) : 0}
                            </TableCell>
                            <TableCell align="center">
                              <Button variant='contained' onClick={() => { setDetail(value); setShowDetail(true) }}>
                                View
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Pagination className='pagnation'
                    count={totalPage}
                    page={page}
                    onChange={(event, value) => {
                      setPage(value);
                    }}
                    variant="outlined"
                    color='primary'
                    shape="rounded" />
                </div>}

            </Grid2>
          </Grid2>
        </Box>
      </Box>
    </div>
  );
};

export default SubAdmin;
